import React from 'react';
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetCompetitionsRulesContent} from "./standings-widget-competitions-rules.content";
import {StandingsWidgetSectionIconTitle} from "../standings-widget.section-icon-title";
import {GameStatsWidgetInfoIconRequestParams} from "../../../game-stats-widget/assests/game-stats-widget.info-icon.request-params";
import {STANDINGS_WIDGET} from "../../standings-widget.consts";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../core/app/consts/colors";

export class StandingsWidgetCompetitionsRulesProps extends BaseProps {
}

export const StandingsWidgetCompetitionsRules = ({controller}: StandingsWidgetCompetitionsRulesProps) => {
  const {state, device: {isSmallView}} = controller;
  const {shouldRenderCompetitionRules, competitionRules, tieBreakTitle} = state;

  if (!shouldRenderCompetitionRules) {
    return null;
  }

  const titleProps = {
    controller,
    label: tieBreakTitle,
    iconSource: new GameStatsWidgetInfoIconRequestParams(STANDINGS_WIDGET.INFO_ICON_SIZE.width, STANDINGS_WIDGET.INFO_ICON_SIZE.height, useThemeColor(COLORS.textSecondary))
  }

  return (
    <div className={classNames(styles.competition_rules_container, {[styles.rules_small_view]: isSmallView})}>
      <StandingsWidgetSectionIconTitle {...titleProps}/>
      <StandingsWidgetCompetitionsRulesContent competitionRules={competitionRules}/>
    </div>)
};